import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/dermatology-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Dermatology() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  // const scrollToSection = (section) => {
  //   sectionsRef[section].current.scrollIntoView({ behavior: "smooth",block:"center" });
  // };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };


  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=Dermatology`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);
  

  const navigate = useNavigate();

  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

      <Navbar />

      <section className="page-section">
          <div className="section-content">
                <p className='page-heading'>Dermatology Department</p>

                <p className="page-subtitle">
                    Comprehensive Dermatology Care for Skin, Hair, and Nail Health 
                </p>

              
                <div className="page-box">
                    <div className="box-content">
                            <p> 
                                The Dermatology Department of Caritas Matha Hospital aims to offer a professional diagnosis and treatment of skin, 
                                hair, and nail disorders. At our facility, we have a team of well-trained dermatologists with skills in the most 
                                modern diagnostic methods and trends in the management of skin ailments.
                            </p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="Dermatology Banner"/>
                    </div>
                </div>
            </div>
        </section>
      <section className="dept-section">
        <div
          ref={sidebarRef}
          className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
        >
          {["overview", "treatment", "facilities", "doctors"].map((section) => (
            <p
              key={section}
              className={`title ${activeSection === section ? "active" : ""}`}
              onClick={() => scrollToSection(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
              {activeSection === section && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="chevron-icon"
                />
              )}
            </p>
          ))}
        </div>
        <div ref={contentRef} className="contents">
          <div ref={sectionsRef.overview} className="overview-content">
            <p className="content-heading">Overview</p>
            {/* Overview content here */}
            <p>
                Caritas Matha Hospital Dermatology Department is a well-established specialist service dedicated to providing quality medical, surgical, and cosmetic dermatology. Skin diseases, including pimples, acne, and skin and hair loss, as well as nail diseases, are diseases that our skin specialists diagnose and treat.
            </p>
            <p>
                Established on the principles of medical professionals and proven technologies, we provide a patient-centered approach to skin treatment that targets the cause of the problem and the ways to improve one’s quality of life. When treating skin disorders or performing cosmetic surgery, our undertaking is to deliver sustainable care with less or no pain.
            </p>
            <p>
                Our department is facilitated with modern diagnostic equipment and overall amenities that create a very conducive atmosphere to attract both patients and their families. It is our mission to educate our patients about their skin condition and what they can do to obtain beautiful, healthy skin.
            </p>
          </div>
          <div ref={sectionsRef.treatment} className="treatment-content">
            <p className="content-heading">Treatment</p>
            {/* Treatment content here */}

            <ul>
                <li><span className="subtitle">Medical Dermatology: </span> Comprehensive care for skin conditions such as psoriasis, eczema, acne, and allergic reactions.</li>
                <br/>

                <li><span className="subtitle">Pediatric Dermatology: </span> Specialized treatment for skin issues affecting infants, children, and adolescents.</li>
                <br/>

                <li><span className="subtitle">Skin Infection Management: </span> An overview of the diagnosis and management of bacterial, viral, fungal skin and scalp infection, and fungal nail infection.</li>
                <br/>

                <li><span className="subtitle">Pigmentation Treatments: </span> New technologies for melasma, hyperpigmentation & dark spots.</li>
                <br/>

                <li><span className="subtitle">Scar and Keloid Management: </span> Methods on how to deal with scars and keloids to improve skin texture.</li>
                <br/>

                <li><span className="subtitle">Psoriasis and Vitiligo Treatment: </span> Treatment for auto-immune skin diseases like psoriasis & vitiligo & phototherapy.</li>
                <br/>

                <li><span className="subtitle">Hair and Scalp Treatments: </span> Solutions for hair loss, dandruff, alopecia, and other scalp-related conditions.</li>
                <br/>

                <li><span className="subtitle">Nail Disorder Treatments: </span> Medical treatment of nail fungus, brittle and deformed nails.</li>
                <br/>

                <li><span className="subtitle">Aesthetic Dermatology: </span> Aimed at skin rejuvenation and improvement of its quality of color and texture.</li>
                <br/>

                <li><span className="subtitle">Anti-aging Therapies: </span> Injectable treatments, skin rejuvenation procedures, and collagen-boosting therapies.</li>
                <br/>

                <li><span className="subtitle">Acne and Acne Scar Treatments: </span> Remedies for acne control and prevention of acne scarring.</li>
                <br/>

                <li><span className="subtitle">Laser and Light Therapies: </span> The latest techniques in laser and light for the removal of pigmentations, scars, and hair.</li>
                <br/>

                <li><span className="subtitle">Skin Allergy Testing and Management: </span> Diagnostic and therapeutic solutions for allergic skin conditions.</li>
                <br/>

                <li><span className="subtitle">Moles and Skin Tag Removal: </span> Non-surgical and non-invasive methods for the treatment of skin tumors.</li>
                <br/>

                <li><span className="subtitle">Dermatosurgery: </span> Surgical solutions for cysts, warts, and other skin lesions.</li>
                <br/>
            </ul>
          </div>
          <div ref={sectionsRef.facilities} className="facilities-content">
            <p className="content-heading">Facilities</p>
            {/* Facilities content here */}
            <ul>
                <li>Modern consultation rooms with advanced diagnostic equipment</li>
                <br/>

                <li>Cutting-edge laser technology for skin and hair treatments</li>
                <br/>

                <li>The availability and utilization of specialized phototherapy units in managing chronic skin diseases</li>
                <br/>

                <li>Advanced cosmetic dermatology treatments for skin rejuvenation</li>
                <br/>

                <li>Stringent health measures to protect the patient's health</li>
                <br/>

                <li>Multidisciplinary collaboration with other specialties for comprehensive care</li>
                <br/>

                <li>Special aftercare and follow-up support</li>
                <br/>

                <li>Custom skincare routines specially designed for each person</li>
                <br/>
            </ul>

            <p>The Dermatology Department of Caritas Matha Hospital aims to deliver the finest clinical service in a comfortable environment. Concerning medical or aesthetic concerns, it is our mission to provide conservative, logical, and evidence-based solutions to every dermatological problem.</p>
          </div>

          <div ref={sectionsRef.doctors} className="doctors">
              <p className="content-heading">Doctors</p>
              {doctors.length > 0 ? (
                <div className='doctorbox-container'>
                    {doctors.map(doctor => (
                      <div key={doctor.id} className="doctorbox">
                          <div className="doctor-box">
                              <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                              <div className='doctor-details'>
                                  <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                  <p>{doctor['designation']}</p>
                                  <p>{ doctor.available_time }</p>
                                  <br/>
                                  {parseInt(doctor.appointment_enabled) === 1 && (
                                      <p>
                                          <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                              Book An Appointment <FaChevronRight />
                                          </a>
                                      </p>
                                  )}
                              </div>
                          </div>
                          <div className='arrow-section'>
                              <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                          </div>
                      </div>
                    ))}
                </div>
              ) : (
                  <p>No doctors available in this department.</p>
              )}
          </div>
        </div>
      </section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default Dermatology;